import React from "react";

export default function MSAccess_InStr() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_InStr</h1>
      <p>This is the MSAccess_InStr component generated from the SQL JSON.</p>
    </div>
  );
}
